import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Body/Headers/Header'
import Footer from '../../components/Body/Footer/SectioFooter';
import Illustration from '../../assets/images/SVG/error-404.svg'

const ErrorPage = () => {
  return (
    <>
      <Header />
      <div className="max-w-6xl mx-auto flex items-center justify-between  pt-20 ">
        <div className="w-1/2">
          <img src={Illustration} alt='Erreur 404' className="w-full px-10"></img>
        </div>
        <div className="w-1/2 px-4 sm:px-6 flex items-center justify-center">
          <div className="">
            <h1 className="text-5xl font-bold">Erreur 404</h1>
            <h2 className="text-xl font-semiBold">Désolé mais cette page n'éxiste pas</h2>
            <button className="rounded-sm bg-indigo-500 hover:bg-indigo-600 py-3 px-6 text-white animate mt-5">
              <Link to='/' className="flex items-center justify-center">
                <svg class="h-5 w-5 mr-2"  fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
                Retourner en page d'accueil
              </Link>
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </>
  )
}

export default ErrorPage;
